import emailjs from "@emailjs/browser";

const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "user_70paf33ZSE4DvGo1z9fbQ";
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_fs00obk";
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_t9ysm1g";
const EMAILJS_CONTACT_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID || "template_i0euepi";
const EMAILJS_ENABLED = process.env.REACT_APP_EMAILJS_ENABLED !== "false";

let hasInitialized = false;

export async function sendRsvpConfirmationEmail({
  email,
  firstName,
  lastName,
  company,
  dinnerSelection,
  dietaryRestrictions,
} = {}) {
  if (!EMAILJS_ENABLED) return { success: false, skipped: true };
  if (!EMAILJS_PUBLIC_KEY || !EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID) return { success: false, skipped: true };
  if (!email) return { success: false, skipped: true };

  try {
    if (!hasInitialized) {
      emailjs.init({ publicKey: EMAILJS_PUBLIC_KEY });
      hasInitialized = true;
    }

    await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, {
      to_email: String(email).trim().toLowerCase(),
      firstName: String(firstName || "").trim(),
      lastName: String(lastName || "").trim(),
      email: String(email).trim().toLowerCase(),
      company: String(company || "").trim(),
      dinnerSelection: String(dinnerSelection || "").trim(),
      dietaryRestrictions: String(dietaryRestrictions || "").trim(),
    });

    return { success: true };
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("EmailJS send failed:", err);
    }
    return { success: false, error: err };
  }
}

export async function sendContactEmail({
  name,
  email,
  company,
  message,
} = {}) {
  if (!EMAILJS_ENABLED) return { success: false, skipped: true };
  if (!EMAILJS_PUBLIC_KEY || !EMAILJS_SERVICE_ID || !EMAILJS_CONTACT_TEMPLATE_ID) return { success: false, skipped: true };
  if (!email) return { success: false, skipped: true };

  try {
    if (!hasInitialized) {
      emailjs.init({ publicKey: EMAILJS_PUBLIC_KEY });
      hasInitialized = true;
    }

    await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_CONTACT_TEMPLATE_ID, {
      fullName: String(name || "").trim(),
      emailAddress: String(email).trim().toLowerCase(),
      companyName: String(company || "").trim(),
      message: String(message || "").trim(),
    });

    return { success: true };
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("EmailJS contact send failed:", err);
    }
    return { success: false, error: err };
  }
}
